import { Table } from '@table/classes/table.class';
import { Paginator } from '@app/classes';
import { ChangeRequest } from '@models/change-requests/change-request.model';
import { AuthService } from '@app/services';
import {
    ApproversColumn,
    RequestTypeColumn,
    SubjectColumn,
    EffectiveAtColumn,
    StatusColumn,
} from '@change-requests/services/tables/change-requests-table/columns';

export class ChangeRequestsIndexTable extends Table {
    links = true;

    constructor(protected auth: AuthService) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        this.addColumns(
            new RequestTypeColumn(),
            new SubjectColumn(),
            new ApproversColumn(),
            new EffectiveAtColumn(),
            new StatusColumn()
        );
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            ChangeRequest.with([
                'template',
                'subject',
                'approvalInstance',
                'approvalInstance.steps',
                'approvalInstance.steps.employee',
            ])
        );
    }
}
